import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getEyesImageReportList } from 'models/eyeCheckImageReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

const routes: CustomRoute = {
	path: '/eye-check-image-new',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eyeCheckImageNew' */ './component')],
			render: ([EyeCheckImageNew]) => <EyeCheckImageNew />,
			onEnter: async ({ store, next }) => {
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.EYE_CHECK_IMAGE_NEW}`);
				if (allowEnter) {
					await store.dispatch(getEyesImageReportList());
				}
				const children = await next();
				return children;
			},
		},
	],
};
export default routes;
